import { useState, useEffect, useCallback } from "react"
import { useAuth } from "@/hooks/useAuth"
import { getAuditStats, type AuditStats } from "@/services/adminService"

export function useAdminStats() {
  const { token } = useAuth()
  const [stats, setStats] = useState<AuditStats | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    if (!token) return
    setLoading(true)
    try {
      const data = await getAuditStats(token)
      setStats(data)
      setError(null)
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load stats")
    } finally {
      setLoading(false)
    }
  }, [token])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { stats, loading, error, refresh }
}
